import * as stylex from "@stylexjs/stylex";
import { X } from "lucide-react";
import { copy } from "@/copy";
import "@/theme/tokens.stylex";
import { colors, motion, space } from "@/theme/tokens.stylex";
import { IconButton } from "@/ui/IconButton";
import type { View } from "./routes";
import type { SidebarMode } from "./sidebar";
import { SIDEBAR_PINNED, SIDEBAR_VIEWS, type SidebarItem } from "./sidebarItems";
type SidebarRailProps = {
  mode: SidebarMode;
  active?: View;
  onHide: () => void;
  onNavigate: (path: string) => void;
};
export function SidebarRail({
  mode,
  active,
  onHide,
  onNavigate
}: SidebarRailProps) {
  const button = (item: SidebarItem) => {
    const current = item.key === active;
    return <IconButton key={item.key} icon={item.icon} label={item.name} size="touch" variant={current ? "solid" : "soft"} current={current ? "page" : undefined} onClick={() => onNavigate(item.path)} />;
  };
  return <nav aria-label={copy.nav.main} inert={mode !== "rail"} {...{
    0: {
      className: "xixxii4 x13vifvy x1ey2m1c xu96u03 xzkaem6 x1dmp6jm x9f619 x1xckggx xh540kj x1hkb6y0 x78zum5 xdt5ytf x6s0dn4 x152posx xb3r6kr xwcsmn1 x1lt0ikf xy1333o"
    },
    2: {
      className: "xixxii4 x13vifvy x1ey2m1c xu96u03 xzkaem6 x1dmp6jm x9f619 x1xckggx xh540kj x1hkb6y0 x78zum5 xdt5ytf x6s0dn4 x152posx xb3r6kr xwcsmn1 x1lt0ikf xy1333o x5i6ehr"
    },
    1: {
      className: "xixxii4 x13vifvy x1ey2m1c xu96u03 xzkaem6 x1dmp6jm x9f619 x1xckggx xh540kj x1hkb6y0 x78zum5 xdt5ytf x6s0dn4 x152posx xb3r6kr xwcsmn1 x1lt0ikf xy1333o xg01cxk"
    },
    3: {
      className: "xixxii4 x13vifvy x1ey2m1c xu96u03 xzkaem6 x1dmp6jm x9f619 x1xckggx xh540kj x1hkb6y0 x78zum5 xdt5ytf x6s0dn4 x152posx xb3r6kr xwcsmn1 x1lt0ikf xy1333o x5i6ehr xg01cxk"
    }
  }[!!(mode === "hidden") << 1 | !!(mode === "expanded") << 0]}>
      <div className="x1iyjqo2 x2lwn1j xh8yej3 xysyzu8 x78zum5 xdt5ytf x6s0dn4 x152posx">
        {SIDEBAR_VIEWS.map(button)}
        <span aria-hidden="true" className="x1iyjqo2 x1hshjfz" />
        {SIDEBAR_PINNED.map(button)}
      </div>
      <div className="x2lah0s x1q88djf">
        <IconButton icon={X} label={copy.nav.hideSidebar} size="touch" onClick={onHide} />
      </div>
    </nav>;
}